module.exports = __webpack_public_path__ + "4f37ea7c92a1df1e7d334e2b5fe06db6.pdf";